/* lcs-headings-getstarted.js — Get Started (membership-form)
   - Promueve “Get Started” → H1 único (id="page-title")
   - Degrada headings vacíos
   - Degrada headings de UI (header, drawers, quick shop, predictive search)
   - “Quick shop” → presentacional
*/

(function () {
  var DEBUG = true;
  function log(){ if (DEBUG && window.console) try{ console.log.apply(console, arguments);}catch(_){} }

  /* === Scope de página: solo /pages/membership-form === */
  var isMembershipForm = /\/pages\/membership-form\/?$/.test(location.pathname);
  if (!isMembershipForm) { log('[GS] Skip — not membership-form'); return; }
  log('[GS] Headings fix loaded on membership-form');

  /* ---------- Utils ---------- */
  function toPresentational(el){
    if (!el || !/^H[1-6]$/i.test(el.tagName)) return;
    var d = document.createElement('div');
    for (var i=0;i<el.attributes.length;i++){
      var a=el.attributes[i];
      d.setAttribute(a.name,a.value);
    }
    d.className += (d.className?' ':'')+'ui-heading';
    d.setAttribute('role','presentation');
    d.setAttribute('aria-hidden','true');
    while(el.firstChild) d.appendChild(el.firstChild);
    el.replaceWith(d);
    log('[GS] Demoted UI heading → DIV', d.className);
  }

  function retagKeepStyles(el, tag){
    if (!el || el.tagName.toLowerCase()===tag) return el;
    var n=document.createElement(tag);
    for (var i=0;i<el.attributes.length;i++){
      var a=el.attributes[i];
      n.setAttribute(a.name,a.value);
    }
    while(el.firstChild) n.appendChild(el.firstChild);
    el.replaceWith(n);
    return n;
  }

  /* ---------- 1) Degradar headings de UI (header, drawers, etc.) ---------- */
  var UI_SCOPES = [
    '#shopify-section-header','header','.site-header','.header',
    'cart-drawer','cart-notification','#CartDrawer','#CartNotification',
    '.cart-drawer','.cart-notification','.cart-popup','.ajaxcart','.mini-cart',
    '[data-cart-drawer]','[data-cart-notification]',
    '.predictive-search','[data-predictive-search]',
    '.quick-add-modal','.quickshop','.quick-add','.product-quickshop',
    '.drawer','.modal','.modal__content'
  ];
  var UI_HEADINGS_SELECTOR = UI_SCOPES.map(function(s){
    return s+' h1, '+s+' h2, '+s+' h3, '+s+' h4, '+s+' h5, '+s+' h6';
  }).join(', ');

  function fixUIHeadings(root){
    var base = (root && root.querySelectorAll) ? root : document;
    base.querySelectorAll(UI_HEADINGS_SELECTOR).forEach(function(h){
      if (h.closest('footer, #shopify-section-footer, [data-section-type="footer"]')) return;
      if (h.dataset.gsDone) return;
      toPresentational(h);
      h.dataset.gsDone = '1';
    });

    // Quick shop específico (título de diálogo)
    var qs = base.querySelector('#dialogQuickShopTitle');
    if (qs && !qs.dataset.gsDone){ toPresentational(qs); qs.dataset.gsDone='1'; }
  }

  /* ---------- 2) Headings vacíos → presentacionales ---------- */
  function fixEmptyHeadings(root){
    var base = (root && root.querySelectorAll) ? root : document;
    base.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function(h){
      if (h.dataset.gsChecked) return;
      var text = (h.textContent || '').replace(/\s+/g,'').trim();
      if (!text.length) toPresentational(h);
      h.dataset.gsChecked = '1';
    });
  }

  /* ---------- 3) Semántica de la página ---------- */
  function fixPageSemantics(){
    // a) Promover “Get Started” a H1
    var candidates = document.querySelectorAll(
      'h1,h2,h3,h4,h5,h6,.s-header__title,.s-header__heading'
    );
    var promoted = null;

    candidates.forEach(function(n){
      var t = (n.textContent || '').trim().toLowerCase();
      if (!promoted && /(^|\s)get\s*started(\s|$)/i.test(t)){
        promoted = retagKeepStyles(n,'h1');
        promoted.id = 'page-title';
        promoted.setAttribute('aria-level','1');
        log('[GS] “Get Started” → H1');
      }
    });

    // b) Asegurar H1 único: si hay otros H1, bajarlos a H2
    var canonicalH1 = document.getElementById('page-title');
    document.querySelectorAll('main h1, body > h1').forEach(function(h){
      if (canonicalH1 && h !== canonicalH1){
        var h2 = retagKeepStyles(h,'h2');
        h2.dataset.gsDone='1';
        log('[GS] Extra H1 → H2');
      }
    });

    // c) “Quick shop” → presentacional
    document.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function(h){
      var txt = (h.textContent || '').trim().toLowerCase();
      if (/^quick\s*shop$/i.test(txt)) toPresentational(h);
    });
  }

  /* ---------- Lanzadores ---------- */
  function kickoff(){
    fixUIHeadings();
    fixEmptyHeadings();
    fixPageSemantics();

    setTimeout(function(){ fixUIHeadings(); fixEmptyHeadings(); fixPageSemantics(); }, 300);
    requestAnimationFrame(function(){ fixUIHeadings(); fixEmptyHeadings(); fixPageSemantics(); });
  }

  if (document.readyState !== 'loading') kickoff();
  else document.addEventListener('DOMContentLoaded', kickoff);

  new MutationObserver(function(muts){
    muts.forEach(function(m){
      (m.addedNodes||[]).forEach(function(n){
        if (n && n.nodeType===1){
          fixUIHeadings(n);
          fixEmptyHeadings(n);
          fixPageSemantics();
        }
      });
    });
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
